/**
 * James's Google Calendar booking page (15-min Year in Review call). Every
 * "book a call" link on the marketing pages points here.
 */
export const BOOKING_URL =
  "https://calendar.google.com/appointments/schedules/AcZssZ3zvsl4xPwZ26mH8A-OaqhT3Z3MmArclCNshJZuX03DiBWcZnvfz5lX8d4znOlOAPmeWTng-66l";
